import styled, { css } from "styled-components";

interface SidebarContainerProps {
  $isOpen: boolean;
  $isFixed: boolean;
}

export const SidebarContainer = styled.aside<SidebarContainerProps>`
  position: absolute;
  top: 0px;
  left: 0;
  height: 100vh;
  background: #fff;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.04);
  z-index: 100;
  transition: width 0.2s cubic-bezier(0.4, 0, 0.2, 1) 150ms;
  width: ${({ $isOpen }) => ($isOpen ? "240px" : "48px")};
  will-change: width;

  ${({ $isOpen, $isFixed }) =>
    !$isOpen &&
    !$isFixed &&
    css`
      &:hover {
        width: 240px;
        transition: width 0.15s cubic-bezier(0.4, 0, 0.2, 1) 150ms;
      }
    `}

  & .fix-sidebar-container {
    height: 64px;
    border-top: 1px solid var(--color-text-input);
  }

  & > div {
    width: inherit;
  }
`;

export const SideBarMenuItem = styled.button<SidebarContainerProps>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;

  height: 48px;
  transition: width 0.2s cubic-bezier(0.4, 0, 0.2, 1) 150ms;
  width: ${({ $isOpen }) => ($isOpen ? "240px" : "48px")};

  font-family: var(--font-paragraph-default);
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text-labels);

  padding: 0;
  padding-left: 12px;

  background: var(--color-light-0);

  span {
    max-width: ${({ $isOpen }) => ($isOpen ? "240px" : "0")};
    opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
    margin-left: 12px;
    overflow: hidden;
    white-space: nowrap;
    transition: max-width 0.2s cubic-bezier(0.4, 0, 0.2, 1) 150ms,
      opacity 0.15s cubic-bezier(0.4, 0, 0.2, 1) 150ms;
    pointer-events: none;
  }

  ${({ $isOpen, $isFixed }) =>
    !$isOpen &&
    !$isFixed &&
    css`
      &:hover {
        width: 240px;
        transition: width 0.15s cubic-bezier(0.4, 0, 0.2, 1) 150ms;
      }
    `}

  svg,
  #boleto-icon {
    fill: var(--color-text-labels);
    z-index: 1;
    width: 24px;
    height: 24px;
  }

  #boleto-icon {
    width: 20px;
    padding-left: 2px;
  }

  &:hover,
  &.active {
    background: var(--color-light-0);

    svg,
    #boleto-icon {
      fill: var(--color-main-rose);
    }

    span {
      color: var(--color-main-rose);
    }
  }

  &::before {
    content: "";
    position: absolute;
    left: 4px;
    top: 50%;
    transform: translateY(-50%);
    width: 4px;
    height: 32px;
    border-radius: 13px;
    background: var(--color-main-rose);
    opacity: 0;
    transition: opacity 0.2s;
    z-index: 0;
  }

  &.active::before,
  &:active::before {
    opacity: 1;
  }

  &.active:hover {
    background: var(--color-rose-100);
  }
`;

export const SideBarSubMenuContainer = styled.div<SidebarContainerProps>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;

  height: 48px;
  transition: width 0.2s cubic-bezier(0.4, 0, 0.2, 1) 150ms;
  width: ${({ $isOpen }) => ($isOpen ? "228px" : "48px")};

  font-family: var(--font-paragraph-default);
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text-labels);

  padding: 0;
  padding-left: 12px;

  background: var(--color-light-0);

  span {
    max-width: ${({ $isOpen }) => ($isOpen ? "240px" : "0")};
    opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
    margin-left: 12px;
    overflow: hidden;
    white-space: nowrap;
    transition: max-width 0.2s cubic-bezier(0.4, 0, 0.2, 1) 150ms,
      opacity 0.15s cubic-bezier(0.4, 0, 0.2, 1) 150ms;
    pointer-events: none;
  }

  ${({ $isOpen, $isFixed }) =>
    !$isOpen &&
    !$isFixed &&
    css`
      &:hover,
      &.semi-active {
        width: 240px;
        transition: width 0.15s cubic-bezier(0.4, 0, 0.2, 1) 150ms;
      }
    `}

  svg {
    fill: var(--color-text-labels);
    z-index: 1;
    width: 24px;
    height: 24px;
  }

  &:hover,
  &.semi-active,
  &.active {
    background: var(--color-light-0);

    svg {
      fill: var(--color-main-rose);
    }

    span {
      color: var(--color-main-rose);
    }
  }

  &::before {
    content: "";
    position: absolute;
    left: 4px;
    top: 50%;
    transform: translateY(-50%);
    width: 4px;
    height: 32px;
    border-radius: 13px;
    background: var(--color-main-rose);
    opacity: 0;
    transition: opacity 0.2s;
    z-index: 0;
  }

  &.active::before,
  &:active::before {
    opacity: 1;
  }

  &.active:hover {
    background: var(--color-rose-100);
  }
`;

export const SideBarSubMenuItem = styled.button<SidebarContainerProps>`
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;

  margin-top: 8px;
  height: 36px;
  width: ${({ $isOpen }) => ($isOpen ? "240px" : "48px")};
  background: var(--color-light-0);
  border: none;
  padding: 0;

  font-family: var(--font-paragraph-default);
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text-labels);

  &:hover {
    background: var(--color-light-0);
  }

  .submenu-content {
    display: flex;
    align-items: center;
    height: 100%;
    width: calc(100% - 36px - 24px);
    background: var(--color-light-0);
    border-radius: 8px;
    margin-left: 36px;
    padding-left: 12px;
    transition: background 0.2s, color 0.2s;
    white-space: nowrap;
    overflow: hidden;
    max-width: ${({ $isOpen }) => ($isOpen ? "204px" : "0")};
    opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  }

  &:hover .submenu-content {
    background: var(--color-rose-100);
    color: var(--color-main-rose);
  }

  &.active .submenu-content {
    background: var(--color-main-rose);
    color: var(--color-light-0);
  }
`;
